import axios from 'axios'

const notesModule = {
    namespaced: true,
    state: {
        notesList: []
    },
    actions: {
        apiRequest(_, data) {

            return axios({
                baseURL: process.env.API + '?comment',
                method: 'POST',
                headers: { 'Content-Type': 'application/json; charset=utf-8' },
                data: {
                    method: 'card_comments',
                    data,
                    debug: false,
                    auth: {
                        sid: window.apiSession,
                        cid: null,
                        demo: false
                    }
                }
            }).then(res => {
                switch(res?.data?.code) {
                    case 105:
                        dispatch('showErrorPopUp', `Введены неверные параметры ${method}`, { root: true })
                        break
                    case 101:
                        dispatch('showErrorPopUp', `Неизвестная ошибка API ${method}`, { root: true })
                        break
                    default:
                        return res
                }
                return res
            }).catch(err => { console.error(err.message) })
        },
        getNotes({ dispatch, commit, rootState }) {
            
            return dispatch('apiRequest', {
                action: 'get_by_card',
                ogrn: parseInt(rootState.card?.company?.ogrn),
                limit: 100
            }).then(res => {
                if(res.data?.data?.cm?.length > 0 && res.data?.code === 0) {
                    commit(
                        'setStateObject', 
                        { name: 'card.notes.notesList', value: res.data.data.cm }, 
                        { root: true }
                    )
                }
            }).catch(err => { console.error(err.message) })
        },
        addNote({ dispatch, rootState }, text) {

            return dispatch('apiRequest', {
                action: 'add_comment',
                ogrn: parseInt(rootState.card?.company?.ogrn),
                text
            }).then(e => {
                if(e.data?.code === 0) {
                    dispatch('getNotes').finally(() => {
                        dispatch('showInfoPopUp', 'Заметка добавлена', { root: true })
                        $('#tiles').trigger('resize')
                    })
                } else {
                    dispatch('showErorPopUp', 'При добавлении заметки произошла ошибка', { root: true })
                }
            }).catch(err => { console.error(err.message) })
        }
    }
}

export default notesModule